module.exports = __webpack_public_path__ + "f1a12b04ca150572a27bc1155f2c668a.gif";